import { ConfigProvider, Modal, Spin } from "antd"
import { FC, useState } from "react"
import { useNavigate } from "react-router"
import { useDeleteProductMutation } from "../../../../../../../graphql"
import { ReactComponent as DangerInfoIcon } from "../../../../../../../icons/danger-info.svg"
import Form from "./components/Form"
import Items from "./components/Items"
import "./index.less"

const LeftSide: FC<ProductManageBlockLeftSideInterface> = ({
  product,
  options,
  filters,
  sizeEnums,
  formatSize,
  colorEnums,
  setOptions,
  setFilters,
  initialFilters,
  selectedProductId,
  isChangesDisabled,
  setInitialFilters,
}) => {
  const navigate = useNavigate()

  const [modalLoading, setModalLoading] = useState<boolean>(false)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const [deleteProduct] = useDeleteProductMutation()

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleModalOk = async () => {
    setModalLoading(true)
    try {
      const productResponse = await deleteProduct({
        variables: {
          id: String(selectedProductId),
        },
      })
      if (productResponse?.data?.deleteProduct?.data?.id) {
        setIsModalOpen(false)
        setTimeout(() => {
          navigate("/account/content/products")
        }, 500)
      }
      setModalLoading(false)
    } catch (error) {
      setModalLoading(false)
    }
  }

  const handleModalCancel = () => {
    setIsModalOpen(false)
  }

  return (
    <div className={"left-side-wrapper"}>
      <ConfigProvider
        theme={{
          components: {
            Input: {
              colorBorder: "#ffffff",
              colorPrimaryHover: "#ffffff",
              controlOutline: "#ffffff",
              colorError: "#ffffff",
              colorErrorBorderHover: "#ffffff",
              colorErrorOutline: "#ffffff",
              colorIcon: "#1C1C23",
              borderRadius: 0,
            },
            Select: {
              colorText: "#000",
              colorPrimaryBorder: "#fff",
              colorPrimaryHover: "#fff",
              controlOutline: "#fff",
              colorBgContainerDisabled: "#fff",
              colorBorder: "#fff",
            },
            Button: {
              borderRadius: 0,
              colorBorder: "#000",
              colorPrimary: "#000",
              colorPrimaryHover: "#707070",
              colorText: "#000",
            },
            Calendar: {
              colorPrimary: "#000",
              colorPrimaryHover: "#707070",
            },
            Collapse: {
              colorBorder: "transparent",
            },
          },
        }}
      >
        <Form
          {...{
            product,
            options,
            filters,
            formatSize,
            setOptions,
            setFilters,
            sizeEnums,
            colorEnums,
            initialFilters,
            selectedProductId,
            isChangesDisabled,
            setInitialFilters,
            showModal,
          }}
        />

        <Items
          {...{
            filters,
            sizeEnums,
            colorEnums,
            setFilters,
            formatSize,
            isChangesDisabled,
          }}
        />

        <Modal open={isModalOpen} onOk={handleModalOk} onCancel={handleModalCancel} className={"product"}>
          <div className={"modal-content-wrapper"}>
            <DangerInfoIcon />
            <p>Are you sure you want to delete an existing product?</p>
            <div className={"loading"}>{modalLoading && <Spin />}</div>
          </div>
        </Modal>
      </ConfigProvider>
    </div>
  )
}

export default LeftSide
